import { computed } from 'vue';
import { useLayoutStore } from '@/store/layout';

export function useLayoutField<T extends keyof ReturnType<typeof useLayoutStore>['layouts'][string]>(
  moduleName: string,
  field: T
) {
  const layoutStore = useLayoutStore();

  return computed({
    get: () => layoutStore.getLayout(moduleName)?.[field],
    set: (val) => {
      layoutStore.updateLayout(moduleName, { [field]: val });
    },
  });
}
